import { render, staticRenderFns } from "./Wendu.vue?vue&type=template&id=664370f4&scoped=true"
import script from "./Wendu.vue?vue&type=script&lang=js"
export * from "./Wendu.vue?vue&type=script&lang=js"
import style0 from "./Wendu.vue?vue&type=style&index=0&id=664370f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664370f4",
  null
  
)

export default component.exports